import * as React from 'react';
import firebase from "../firebase/firebase";

const PostActivity = (data) => new Promise(async (resolve, reject) => {

  const activitiesRef = firebase.firestore().collection('activities');
  try {
    const add = await activitiesRef.add({
      ...data,
      read: false,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    })
    resolve(add.id)
  } catch (e) {
    reject()
  }
});
export default PostActivity;